// For Repository ReportTokenUsage
import type { AsyncData } from '#app';
import type { IModelResponse } from '~/services/base/dto/base.dto';
import type {
  IModelGETReportTokenUsageIdRequest,
  IModelGETReportTokenUsageIdResponse,
  IModelGETReportTokenUsageRequest,
  IModelGETReportTokenUsageResponse,
  IModelGETReportTokenUsageSummaryRequest,
  IModelGETReportTokenUsageSummaryResponse,
} from './dto/report-token-usage.dto';
import { ENUM } from '~/plugins/constants/enum';

export class ReportTokenUsageRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getReportTokenUsage(
    params: IModelGETReportTokenUsageRequest
  ): Promise<AsyncData<IModelGETReportTokenUsageResponse, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/report-token-usage`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getReportTokenUsageSummary(
    params: IModelGETReportTokenUsageSummaryRequest
  ): Promise<
    AsyncData<IModelResponse<IModelGETReportTokenUsageSummaryResponse>, any>
  > {
    let dataResult = await this.api(
      `${this.llmService}/v1/report-token-usage/summary`,
      this.configService,
      {
        params,
      }
    );

    dataResult.data.value = {
      message: ENUM.API_RESPONSE_MESSAGE.SUCCESS,
      data: {
        ...dataResult.data.value,
      },
    };
    return dataResult;
  }

  async getReportTokenUsageId(
    params: IModelGETReportTokenUsageIdRequest
  ): Promise<
    AsyncData<IModelResponse<IModelGETReportTokenUsageIdResponse>, any>
  > {
    const dataResult = await this.api(
      `${this.llmService}/v1/report-token-usage/${params.id}`,
      this.configService
    );
    return dataResult;
  }

  async exportReportTokenUsageSummary(
    params: any
  ): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/report-token-usage/export`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async exportReportFeedback(params: any): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/conversation-association/export-feedback`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }
}
